import * as React from 'react';
import { WebPage } from '@grandvisionhq/analytics';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { MediaQuery } from '@grandvisionhq/common';
import { ProductDetailTitleView, BrandPromotionView, UnpublishedProductImageView, StickyAside, UnpublishedProductEcommContentView } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { getFrontImage } from '@grandvisionhq/utils';
import { getActiveVariant, getVariantDescription } from '../../helpers.js';
import { useProductDetailContext } from '../Context/ProductDetailContext.js';
import { useBrandLink } from '../utils/use-brand-link.js';

const UnpublishedPDP = ({ productUrl , brandPromotions  })=>{
    const { activeVariant , product , productType  } = useProductDetailContext();
    const { locale  } = useIntl();
    const brandURL = useBrandLink(product);
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const containerRef = React.useRef(null);
    if (!productType || !activeVariant) {
        return null;
    }
    const variant = getActiveVariant(product, activeVariant.sku);
    const imageUrl = getFrontImage(activeVariant.images).url;
    const productColor = getVariantDescription(variant, locale);
    let title;
    if (CommerceToolsApi.isLenses(activeVariant)) {
        title = `${activeVariant.brand}`;
    } else if (CommerceToolsApi.isSolutions(activeVariant)) {
        title = `${activeVariant.modelName} ${activeVariant.contactLensCareType} ${activeVariant.packageOption}`;
    } else {
        title = `${activeVariant.brand} ${activeVariant.modelName}`;
    }
    const subTitle = CommerceToolsApi.isLenses(activeVariant) ? activeVariant.replacementFrequency : activeVariant.brand;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: "site-container product-detail__container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main"
    }, isSmallScreen && /*#__PURE__*/ React.createElement("div", {
        className: "desktop-hidden product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: title,
        subtitle: subTitle,
        href: brandURL,
        sku: activeVariant.sku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, /*#__PURE__*/ React.createElement(BrandPromotionView, {
        brandPromotions: brandPromotions || [],
        brandName: activeVariant.brand,
        className: "product-detail__brand-promotion"
    }), /*#__PURE__*/ React.createElement(UnpublishedProductImageView, {
        src: imageUrl,
        alt: title
    })), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail__aside",
        "aria-label": title
    }, /*#__PURE__*/ React.createElement(StickyAside, {
        bottomBoundary: '.product-detail',
        isEnabled: !isSmallScreen
    }, !isSmallScreen && /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: title,
        subtitle: subTitle,
        href: brandURL,
        sku: activeVariant.sku
    })), /*#__PURE__*/ React.createElement(UnpublishedProductEcommContentView, {
        productColor: productColor
    }))))), /*#__PURE__*/ React.createElement(WebPage, {
        url: productUrl,
        pageType: "ProductDetail",
        name: activeVariant.brand,
        description: activeVariant.description
    }));
};

export { UnpublishedPDP };
//# sourceMappingURL=UnpublishedPDP.js.map
